.panel {
  padding: 12px 0;
}

.heading {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-text-muted);
  margin: 0 0 10px;
}

/*
 * Two-column grid by default (inline / narrow screens).
 * Switches to single column at ≥900px (sidebar context) and at ≤480px (very small).
 * The sidebar parent is only shown at ≥900px, so the single-column rule there
 * produces a vertical list, which is the desired sidebar layout.
 */
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

@media (min-width: 900px) {
  .grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .grid {
    grid-template-columns: 1fr;
  }
}

.card {
  background-color: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: 6px;
  box-shadow: var(--color-shadow-card);
  overflow: hidden;
  cursor: pointer;
  display: flex;
  align-items: stretch;
  transition: box-shadow 0.2s;
  text-decoration: none;
}

.card:hover,
.card:focus-visible {
  box-shadow: 0 4px 12px var(--color-shadow);
  outline: none;
}

.cardImage {
  width: 64px;
  flex-shrink: 0;
  object-fit: cover;
  display: block;
  align-self: stretch;
}

.cardBody {
  flex: 1;
  padding: 8px 10px;
  min-width: 0;
  display: flex;
  align-items: flex-start;
}

.cardTitle {
  margin: 0;
  font-size: 0.82rem;
  line-height: 1.3;
  color: var(--color-text-primary);
  font-weight: 600;
}
